export const CartGelsoftMX = () => {
    return (
        <>
            Cart!!!
        </>
    )
} 